"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _injectSheet = _interopRequireDefault(require("../style/injectSheet"));
/*:: // 

import { type Node } from 'react';*/
/*:: import { type ThemeType, type InjectSheetProvidedProps } from '../style/ThemeTypes';*/
var Style = function Style(theme /*: ThemeType*/) {
  return {
    root: {
      borderTop: '1px solid transparent',
      '&:first-child': {
        borderTopColor: theme.colors.pastelGrey
      },
      '&:nth-child(even)': {
        '&, & td': {
          backgroundColor: theme.colors.ghostWhite
        }
      }
    }
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  /**
   * Child nodes
   *-/
  children?: Node
};*/
function MarkdownTableRow(props /*: Props*/) /*: Node*/{
  var children = props.children,
    classes = props.classes;
  return /*#__PURE__*/_react.default.createElement("tr", {
    className: classes.root
  }, children);
}
MarkdownTableRow.displayName = 'MarkdownTableRow';
var _default = exports.default = (0, _injectSheet.default)(Style)(MarkdownTableRow);
//# sourceMappingURL=TableRow.js.map